import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { P } from "../../utils/permissions";
import { Routes as AppRoutes } from "../../routes";
import { hasRole } from "../../helpers/roleNames";

/**
 * Admin orders list (/orders) only.
 * VA distributors hitting this URL are sent to /distributor.
 */
export function RequireAdminOrdersHome() {
  const { hasPermission } = useAuth();
  const outletContext = useOutletContext();

  if (
    hasPermission(P.ORDERS_READ_ALL) ||
    hasPermission(P.ORDERS_READ_VA)
  ) {
    return <Outlet context={outletContext} />;
  }

  if (hasPermission(P.ORDERS_READ_ASSIGNED)) {
    return <Navigate to={AppRoutes.VaDistributorHome.path} replace />;
  }

  if (hasPermission(P.ORDERS_READ_OWN)) {
    return <Navigate to={AppRoutes.AudiologistHome.path} replace />;
  }

  return <Navigate to={AppRoutes.AccessDenied.path} replace />;
}

/**
 * VA distributor routes (/distributor/*) only.
 * Admins hitting these URLs are sent to /orders.
 */
export function RequireVaDistributorHome() {
  const { hasPermission } = useAuth();
  const outletContext = useOutletContext();

  if (
    hasPermission(P.ORDERS_READ_ALL) ||
    hasPermission(P.ORDERS_READ_VA)
  ) {
    return <Navigate to={AppRoutes.Orders.path} replace />;
  }

  if (hasPermission(P.ORDERS_READ_ASSIGNED)) {
    return <Outlet context={outletContext} />;
  }

  return <Navigate to={AppRoutes.AccessDenied.path} replace />;
}

/**
 * Distributor settings, or va-admin password settings.
 * Full admins are sent back to /orders.
 */
export function RequireVaSettings() {
  const { hasPermission, roles } = useAuth();
  const outletContext = useOutletContext();
  const isDistributor =
    hasPermission(P.ORDERS_READ_ASSIGNED) && !hasPermission(P.ORDERS_READ_ALL);
  const isVaAdminPassword =
    hasRole(roles, "va-admin") && !hasPermission(P.ORDERS_READ_ASSIGNED);

  if (isDistributor || isVaAdminPassword) {
    return <Outlet context={outletContext} />;
  }

  if (
    hasPermission(P.ORDERS_READ_ALL) ||
    hasPermission(P.ORDERS_READ_VA)
  ) {
    return <Navigate to={AppRoutes.Orders.path} replace />;
  }

  return <Navigate to={AppRoutes.AccessDenied.path} replace />;
}
